import {
  Box,
  Divider,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Spinner,
  Text
} from '@chakra-ui/react'
import { FC } from 'react'
import { MdHistory } from 'react-icons/md'

import FuModalHeader from '@component/FollowUpFornecedor/ModalHeader'

import { StatusAprovacao } from '@service/followUpFornecedor'

import { aprovacaoBadge } from '../../utils/followUpFornecedor/badges'

// tipoEvento: 1=Submissao, 2=Decisao, 3=RevisaoComprador
export interface IHistoricoRodada {
  email: string | null
  rodada: number | null
  novaQuantidade: number | null
  novaDataEntrega: string | null
  observacao: string | null
  statusAprovacao: number | null
  observacaoAprovador: string | null
  aprovadoEm: string | null
  emailAprovador: string | null
  dataEvento: string
  tipoEvento: 1 | 2 | 3
}

export interface HistoricoState {
  open: boolean
  loading: boolean
  nomeProduto: string
  documentId: number | null
  rodadas: IHistoricoRodada[]
}

interface Props {
  historico: HistoricoState
  onClose: () => void
}

const HistoricoModal: FC<Props> = ({ historico, onClose }) => (
  <Modal
    isOpen={historico.open}
    onClose={onClose}
    isCentered
    scrollBehavior="inside"
    size="lg"
  >
    <ModalOverlay />
    <ModalContent>
      <FuModalHeader
        bg="#4c1d95"
        icon={MdHistory}
        title="Histórico do Par"
        subtitle={`Doc. ${historico.documentId} · ${historico.nomeProduto}`}
      />
      <ModalCloseButton color="white" />
      <ModalBody bg="white" py={5}>
        {historico.loading ? (
          <Flex justify="center" align="center" py={10}>
            <Spinner color="purple.500" size="lg" />
          </Flex>
        ) : historico.rodadas.length === 0 ? (
          <Text color="gray.400" textAlign="center" py={8}>
            Nenhum histórico encontrado para este par.
          </Text>
        ) : (
          <Box position="relative">
            {historico.rodadas.map((rodada, idx) => {
              const isSubmissao = rodada.tipoEvento === 1
              const isDecisao = rodada.tipoEvento === 2
              const isRevisaoComprador = rodada.tipoEvento === 3

              const dotBg = isDecisao
                ? rodada.statusAprovacao === StatusAprovacao.Aprovado
                  ? 'green.500'
                  : rodada.statusAprovacao === StatusAprovacao.Recusado
                  ? 'red.500'
                  : 'gray.400'
                : isRevisaoComprador
                ? 'blue.400'
                : 'purple.400'

              return (
                <Box
                  key={`${rodada.rodada ?? idx}-${rodada.tipoEvento}`}
                  position="relative"
                  pl={8}
                  mb={5}
                >
                  {idx < historico.rodadas.length - 1 && (
                    <Box
                      position="absolute"
                      left="11px"
                      top="22px"
                      bottom="-20px"
                      w="2px"
                      bg="gray.200"
                    />
                  )}
                  <Box
                    position="absolute"
                    left="2px"
                    top="4px"
                    w="18px"
                    h="18px"
                    borderRadius="full"
                    bg={dotBg}
                    border="2px solid white"
                    boxShadow="sm"
                  />
                  <Box
                    borderWidth="1px"
                    borderColor="gray.200"
                    borderRadius="lg"
                    p={3}
                    bg="gray.50"
                  >
                    <Text fontSize="11px" color="gray.400" mb={2}>
                      {new Date(rodada.dataEvento).toLocaleString('pt-BR')}
                    </Text>

                    {isSubmissao ? (
                      <Text fontSize="12px" color="gray.500" mb={2}>
                        Submissão por{' '}
                        <Text as="span" fontWeight="600" color="gray.700">
                          {rodada.email}
                        </Text>
                      </Text>
                    ) : isDecisao ? (
                      <Text fontSize="12px" color="gray.500" mb={2}>
                        Decisão por{' '}
                        <Text as="span" fontWeight="600" color="gray.700">
                          {rodada.emailAprovador}
                        </Text>
                      </Text>
                    ) : (
                      <Text fontSize="12px" color="gray.500" mb={2}>
                        Revisão direta por{' '}
                        <Text as="span" fontWeight="600" color="gray.700">
                          {rodada.emailAprovador}
                        </Text>
                      </Text>
                    )}

                    {(isSubmissao || isRevisaoComprador) &&
                      (rodada.novaQuantidade != null ||
                        rodada.novaDataEntrega) && (
                        <Flex gap={6} wrap="wrap" mt={1}>
                          {rodada.novaQuantidade != null && (
                            <Box>
                              <Text fontSize="11px" color="gray.400">
                                Qtd.
                              </Text>
                              <Text
                                fontSize="13px"
                                fontWeight="700"
                                color="green.600"
                              >
                                {rodada.novaQuantidade}
                              </Text>
                            </Box>
                          )}
                          {rodada.novaDataEntrega && (
                            <Box>
                              <Text fontSize="11px" color="gray.400">
                                Data
                              </Text>
                              <Text
                                fontSize="13px"
                                fontWeight="700"
                                color="green.600"
                              >
                                {new Date(
                                  rodada.novaDataEntrega
                                ).toLocaleDateString('pt-BR')}
                              </Text>
                            </Box>
                          )}
                        </Flex>
                      )}

                    {rodada.observacao && (
                      <Text
                        fontSize="12px"
                        color="gray.600"
                        fontStyle="italic"
                        mt={2}
                      >
                        {rodada.observacao}
                      </Text>
                    )}

                    {isDecisao && rodada.statusAprovacao !== null && (
                      <>
                        <Divider my={2} />
                        {aprovacaoBadge(rodada.statusAprovacao)}
                        {rodada.aprovadoEm && (
                          <Text fontSize="11px" color="gray.400" mt={1}>
                            {new Date(rodada.aprovadoEm).toLocaleString(
                              'pt-BR'
                            )}
                          </Text>
                        )}
                        {rodada.observacaoAprovador && (
                          <Text
                            fontSize="12px"
                            color="gray.600"
                            fontStyle="italic"
                            mt={1}
                          >
                            {rodada.observacaoAprovador}
                          </Text>
                        )}
                      </>
                    )}
                  </Box>
                </Box>
              )
            })}
          </Box>
        )}
      </ModalBody>
    </ModalContent>
  </Modal>
)

export default HistoricoModal
